import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { NATURAL_NUMBER_REGEXP } from 'components/ShoppingQuote/BOTProductAndServicesQuote/constants'
import SaveForLaterQuantityInput from './SaveForLaterQuantityInput'


const withQuantityHandlers = withHandlers({
  increaseHandler: ({
    quantity,
    setQuantity,
    maxValue = Infinity,
    step = 1,
    onChange
  }) => () => {
    if (quantity < maxValue) {
      const newQuantity = (parseInt(quantity, 10) + step).toString()
      if ((newQuantity.match(NATURAL_NUMBER_REGEXP)) || !newQuantity) {
        setQuantity(newQuantity)
        onChange(newQuantity)
      }
    }
  },
  decreaseHandler: ({
    quantity,
    setQuantity,
    minValue = 0,
    step = 1,
    onChange
  }) => () => {
    if (quantity > minValue) {
      const newQuantity = (parseInt(quantity, 10) - step).toString()
      if ((newQuantity.match(NATURAL_NUMBER_REGEXP)) || !newQuantity) {
        setQuantity(newQuantity)
        onChange(newQuantity)
      }
    }
  }
})

const withQuantityUpdateFromProps = lifecycle({
  componentDidUpdate({ value }) {
    if (this.props.value !== value) {
      this.props.setQuantity(this.props.value)
    }
  }
})

const withQuantityState = withState('quantity', 'setQuantity', ({ value }) => value)

export default compose(
  connect(null, { }),
  withQuantityState,
  withQuantityHandlers,
  withQuantityUpdateFromProps
)(SaveForLaterQuantityInput)
